<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dados",
    "dado",
    "dadoOriginal",
    "gerandoPagamentos",
]);

const emits = defineEmits([
    "update:alteraVisualizandoDado",
    "update:alteraLiberandoDado",
    "update:alteraAprovandoDado",
    "update:alteraGerandoPagamentos",
    "update:alteraBaixandoDado",
]);

//==================================================================//
//==================== Altera Visualizando Dado ====================//
//==================================================================//

const alteraVisualizandoDado = (update = {})=>{

    update.dadoOriginal = props?.dadoOriginal;
    emits('update:alteraVisualizandoDado',update);

};

//==================================================================//
//====================== Altera Liberando Dado =====================//
//==================================================================//

const alteraLiberandoDado = (update = {})=>{

    update.dadoOriginal = props?.dadoOriginal;
    emits('update:alteraLiberandoDado',update);

};

//==================================================================//
//====================== Altera Aprovando Dado =====================//
//==================================================================//

const alteraAprovandoDado = (update = {})=>{

    update.dadoOriginal = props?.dadoOriginal;
    emits('update:alteraAprovandoDado',update);

};

//==================================================================//
//=================== Altera Gerando Pagamento =====================//
//==================================================================//

const alteraGerandoPagamentos = (update = {})=>{

    update.dadoOriginal = props?.dadoOriginal;
    emits('update:alteraGerandoPagamentos',update);

};

//==================================================================//
//======================= Altera Baixando Dado =====================//
//==================================================================//

const alteraBaixandoDado = (update = {})=>{

    update.dadoOriginal = props?.dadoOriginal;
    emits('update:alteraBaixandoDado',update);

};

//==================================================================//
//========================= Pemite Liberar =========================//
//==================================================================//

const permiteLiberar = computed(()=>{

    return props?.dado?.contasAPagar?.some((contaAPagar)=>{

        return contaAPagar?.status == "Prevista"

    });

});

//==================================================================//
//========================= Pemite Aprovar =========================//
//==================================================================//

const permiteAprovar = computed(()=>{

    return props?.dado?.contasAPagar?.some((contaAPagar)=>{

        return  contaAPagar?.status == "Aguardando Aprovação"
    });

});

//==================================================================//
//===================== Pemite Gerar Pagamentos ====================//
//==================================================================//

const permiteGerarPagamento = computed(()=>{

    return props?.dado?.contasAPagar?.some((contaAPagar)=>{

        return  contaAPagar?.status == "Liberada" &&
                contaAPagar?.valorParaReservar > 0;

    });

});

//==================================================================//
//========================== Pemite Baixar =========================//
//==================================================================//

const permiteBaixar = computed(()=>{

     return props?.dado?.contasAPagar?.some((contaAPagar)=>{

        if(
            contaAPagar?.status != "Liberada" ||
            contaAPagar?.forma != "Boleto" ||
            contaAPagar?.pagamentosQuantidade <= 0
        ){
            return false;
        }

        return contaAPagar?.pagamentos?.some((pagamento)=>{

            return pagamento?.status == "Pagamento não realizado";

        });

    });

});

//==================================================================//
//======================== ao Visualizar Dado ======================//
//==================================================================//

const aoVisualizarDado = ()=>{

    alteraVisualizandoDado()

};

//==================================================================//
//========================== ao Liberar Dado =======================//
//==================================================================//

const aoLiberarDado = ()=>{

    alteraLiberandoDado();

};

//==================================================================//
//========================== ao Aprovar Dado =======================//
//==================================================================//

const aoAprovarDado = ()=>{

    alteraAprovandoDado();

};

//==================================================================//
//====================== ao Gerar Pagamentos =======================//
//==================================================================//

const aoGerarPagamentos = ()=>{

    alteraGerandoPagamentos();

};

//==================================================================//
//====================== ao Gerar Pagamentos =======================//
//==================================================================//

const aoBaixarDado = ()=>{

    alteraBaixandoDado();

};

</script>

<template>

    <div
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content c-controles">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-visualizar-dado mx-2"
                            fab
                            dark
                            small
                            color="#32434D"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoVisualizarDado"
                        >

                            <v-icon dark>
                                mdi-eye
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Visualizar {{ props?.dado?.tipo }}
                    </span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="permiteLiberar"
                            class="c-liberar-dado mx-2"
                            fab
                            dark
                            small
                            color="#3E737B"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoLiberarDado"
                        >

                            <v-icon dark>
                                mdi-check-circle-outline
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Liberar Contas a Pagar
                    </span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="permiteAprovar"
                            class="c-aprovar-dado mx-2"
                            fab
                            dark
                            small
                            color="#4F6563"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoAprovarDado"
                        >

                            <v-icon 
                                dark
                            >
                                mdi-gavel
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Aprovar Contas a Pagar
                    </span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="permiteGerarPagamento"
                            class="c-gerar-pagamentos mx-2"
                            fab
                            dark
                            small
                            color="#929B80"
                            v-bind="attrs"
                            v-on="on"
                            :loading="props?.gerandoPagamentos"
                            @click="aoGerarPagamentos"
                        >

                            <v-icon dark>
                                mdi-cash-plus
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Gerar Pagamentos
                    </span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="permiteBaixar"
                            class="c-baixar-dado mx-2"
                            fab
                            dark
                            small
                            color="#4F5951"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoBaixarDado"
                        >

                            <v-icon dark>
                                mdi-receipt-text-arrow-right
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Baixar Contas a Pagar
                    </span>

                </v-tooltip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span><strong>{{dado?.sigla}}: </strong><span>{{dado?.codigo}}</span></span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ dado?.status }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <span><strong>{{dado?.credorTipo}}<br></strong><span>{{dado?.credorNome}}</span></span>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorOriginal) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorParaReservar) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorDesconto) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorPagamento) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorReservado) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorParaPagar) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorPago) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorParaVincular) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{ UtilMoney.toR$BRL(dado?.valorVinculado) }}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="indigo"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-receipt-text
                    </v-icon>
                    {{dado?.contasAPagarQuantidade}}

                </v-chip>
            
            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="primary"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-cash-multiple
                    </v-icon>
                    {{dado?.pagamentosQuantidade}}

                </v-chip>
                
            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*============================ Table ===============================*/
/*==================================================================*/

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell--principal{
    border-left: 10px solid #1976d2;
    border-radius: 5px;
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

</style>
